// Printed invoices use accounting notation: a negative line (a discount or admin cost) reads as
// (500.00) rather than -500.00. Display only; every calculation keeps the signed number.
export const formatInvoiceAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "0.00";

  const fixed = Math.abs(amount).toFixed(2);
  const isNegative = amount < 0 && Number(fixed) !== 0;
  return isNegative ? `(${fixed})` : fixed;
};
